import React from "react";
import type { FilterProps, SelectionEvent, SelectOption } from "../../../../viewmodels/qaReports/qaReportTypes";
// @ts-expect-error The legacy select wrapper has no TypeScript declarations.
import SelectMenu from "../../../controls/SelectMenu";
// @ts-expect-error The legacy input has no TypeScript declarations.
import Input from "../../../controls/Input";

export default function ProductionSummaryFilter(props: FilterProps & { classes: SelectOption[]; categories: SelectOption[] }) {
  const { filters, setFilters, classes, categories, disabled } = props;
  return (
    <div className="grid grid-cols-6 gap-3">
      <SelectMenu
        title="Class"
        disabled={disabled}
        handleInputChange={(e: SelectionEvent) =>
          setFilters({ ...filters, class: e.target.value })
        }
        name="class"
        options={classes}
        value={filters.class}
      />
      <SelectMenu
        title="Category"
        disabled={disabled}
        handleInputChange={(e: SelectionEvent) =>
          setFilters({ ...filters, category: e.target.value })
        }
        name="category"
        options={categories}
        value={filters.category}
      />
       <Input
              label="Lot number"
              name="lotNumber"
              value={filters.lotNumber}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilters({ ...filters, lotNumber: e.target.value })}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />
    </div>
  );
}
